import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  submit() {
    this.buttonTarget.disabled = true
    this.buttonTarget.value = "Saving…"
  }

  success(event) {
    this.buttonTarget.disabled = false
    if (event.detail.success) {
      this.buttonTarget.value = "Saved ✓"
      setTimeout(() => { this.buttonTarget.value = "Save" }, 1500)
    } else {
      this.buttonTarget.value = "Error"
      setTimeout(() => { this.buttonTarget.value = "Save" }, 2000)
    }
  }
}
